import React, { useState } from "react";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import classes from "./styles/style.module.css";
import CardImage from "../../../assets/images/background/Card.png";
import { useSelector } from "react-redux";
import { convertToShamsi } from "../../../assets/utils/ConvertToShamsi";
import appApi from "../../../assets/utils/AppApi";
import errorHandler from "../../../assets/utils/ErrorHandler";
import WinModal from "../../../assets/thridParty/WinModal";
import Loading from "../../../assets/containers/loadingDialog";

const GoldenCard = () => {
  const { currentUser } = useSelector(({ user }) => user);
  const [cardNumber, setCardNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [prize, setPrize] = useState([]);
  const [showWinModal, setShowWinModal] = useState(false);

  const formatCardNumber = (input) => {
    const cleanedInput = input.replace(/\s+/g, "");
    const formattedInput = cleanedInput.match(/.{1,4}/g)?.join(" ") || "";

    return formattedInput;
  };

  const handleChange = (e) => {
    const formattedValue = formatCardNumber(e.target.value);
    setCardNumber(formattedValue);
  };

  const handleSubmit = () => {
    if (cardNumber.length === 19) {
      const cleanedStr = cardNumber.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      const chunks = [];
      for (let i = 0; i < cleanedStr.length; i += 4) {
        chunks.push(cleanedStr.slice(i, i + 4));
      }
      const result = chunks.join("-");
      setLoading(true);
      appApi
        .post("/key/redeem", {
          key: result,
        })
        .then(({ data }) => {
          setCardNumber("");
          setPrize(data.prize);
          setLoading(false);
          setShowWinModal(true);
        })
        .catch((error) => {
          errorHandler(error);
          setLoading(false);
        });
    }
  };

  return (
    <AnimatedPageContainer>
      <div className="customContainer py-1">
        <div className={classes.hint}>
          کلید جایزه دریافتی خود را در کارت طلایی جفت پوچ وارد کنید.😊 🏆
        </div>
        <div className={`${classes.cardContainer} shadow-lg`}>
          <img src={CardImage} alt="card" className={classes.Cardimage} />
          <span className={classes.title}>کارت طلایی</span>
          <div className={classes.inputContainer}>
            <input
              type="text"
              value={cardNumber}
              onChange={handleChange}
              placeholder="**** **** **** ****"
              maxLength={19}
              style={{
                padding: "10px",
                fontSize: "16px",
                width: "100%",
                textAlign: "center",
                fontFamily: "Arial",
              }}
            />
          </div>
          <div className={classes.nameContainer}>
            <span>تاریخ: {convertToShamsi(Date.now())}</span>
            <span>{currentUser?.fullName}</span>
          </div>
        </div>
        <div className={classes.buttonContainer}>
          {loading ? (
            <Loading className={"d-flex justify-content-center"} light={true} />
          ) : (
            <button onClick={handleSubmit}>ثبت</button>
          )}
        </div>
      </div>
      <WinModal
        show={showWinModal}
        handleClose={() => {
          setShowWinModal(false);
        }}
        prize={"تبریک !!!"}
        desc={
          <>
            <span>کارت شما با موفقیت استفاده شد</span>
            <p>
              جوایز شما :
              {prize.map((item) => {
                if (item.type === "JoftPoochScore") {
                  return <span>امتیاز جفت پوچ({item.value}) </span>;
                } else {
                  return <span>سکه جفت پوچ({item.value})</span>;
                }
              })}
            </p>
          </>
        }
      />
    </AnimatedPageContainer>
  );
};

export default GoldenCard;
